const mvc = require('../mvc')
var BN = mvc.crypto.BN
module.exports = BN
